<template>
    <div class="is-align-self-flex-end">
        <div class="modal" :class="{'is-active': modalVisible}">
            <div class="modal-background"></div>
                <div class="modal-card">
                    <header class="modal-card-head">
                    <p class="modal-card-title">Instituições</p>
                    <button class="delete" aria-label="close" @click="closeModal()"></button>
                    </header>
                    <section class="modal-card-body">
                        <table class="table is-hoverable is-fullwidth has-text-left">
                            <tbody>
                                <tr>
                                    <th></th>
                                    <th>Seq.</th>
                                    <th>Instituição</th>
                                    <th>Município</th>
                                    <th>Cargo</th>
                                    <th>Data Início e Término</th>
                                    <th>Regime Jurídico</th>
                                    <th>Quadro Funcional</th>
                                    <th>Vínculo</th>
                                    <th>Situação Funcional</th>
                                </tr>

                                <tr v-for="institution in institutions" v-bind:key="institution.sequenceCode">
                                <td>
                                    <label class="checkbox">
                                        <input type="checkbox" v-model="institution.selected" />
                                    </label>
                                </td>
                                <td>{{ institution.sequenceCode }}</td>
                                <td>{{ institution.name }}</td>
                                <td>{{ institution.city }}</td>
                                <td>{{ institution.role }}</td>
                                <td>{{ institution.period }}</td>
                                <td>{{ institution.legalRegime }}</td>
                                <td>{{ institution.staff }}</td>
                                <td>{{ institution.status }}</td>
                                <td>{{ institution.functionStatus }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </section>
                    <footer class="modal-card-foot">
                    <div class="buttons">
                        <button class="button is-success" @click="handleSave()">Salvar</button>
                        <button class="button" @click="closeModal()">Cancelar</button>
                    </div>
                    </footer>
                </div>
        </div>
        <div class="buttons">
            <button class="button" @click="openModal()">Selecionar Instituição</button>
        </div>
    </div>
</template>
  
<script>
export default {
    props: ['value', 'institutions'],
    data() {
        return {
            modalVisible: false
        }
    },
    methods: {
        handleSave () {
            let selectedInstitutions = [];

            this.institutions.forEach(inst => {
                if (inst.selected) selectedInstitutions.push(inst.sequenceCode);
            });

            this.$emit('institutionsSelected', selectedInstitutions);
            this.closeModal();
        },
        openModal() {
            this.modalVisible = true;
        },
        closeModal() {
            this.modalVisible = false;
        }
    }
}
</script>

<style>
    .modal-card {
        width: 90%;
    }
        
</style>